module.exports = ol.structs.LRUCache;